// -- import * as _ from "lodash-es"
import Vue from "vue"
import * as tools from "./tools"
// import endpoints_setting from "./endpoints_setting";
import { parse } from "date-fns"
import * as api from "./api"
import * as base_url from "./base_url"

const get_path = info => {
  let path = info.content_path
  if (!path) path = "biz_data"
  return path
}

export const extract_oject = function (query_result, index = 0) {
  return query_result[index].result.data[0]
}

export const extract_list = function (query_result, index = 0) {
  return query_result[index].result.data
}

export const init_biz_data = function (dataContainer, data_info) {
  let data = data_info.data
  let parent = _.get(dataContainer, get_path(data_info))
  let biz_data = parent[data_info.content_type]
  if (_.isArray(biz_data) && _.isArray(data)) {
    biz_data.splice(0)
    _.each(data, o => {
      biz_data.splice(0, 0, o)
    })
  } else if (_.isPlainObject(biz_data) && _.isPlainObject(data)) {
    _.each(data, (v, k) => {
      Vue.set(biz_data, k, v)
    })
  }
}

export const add_biz_data = function (state, data_info) {
  let data = data_info.data
  console.log(state)
  let path = get_path(data_info)
  console.log(path)
  let biz_data = _.get(state, path)[data_info.content_type]
  if (!_.isArray(biz_data)) return
  if (_.isArray(data)) {
    _.each(data, o => {
      biz_data.push(o)
    })
  } else if (_.isPlainObject(data)) {
    biz_data.push(data)
  }
}

export const remove_biz_data = function (state, data_info) {
  let biz_data = _.get(state, get_path(data_info))[data_info.content_type]
  let search_by = data_info.search_by
  if (!_.isArray(biz_data)) return
  let indexes = tools.findIndexAll(biz_data, search_by)
  _.each(indexes, index => {
    biz_data.splice(index, 1)
  })
}

export const update_biz_data = function (state, data_info) {
  let data = data_info.data
  let biz_data = _.get(state, get_path(data_info))[data_info.content_type]
  let search_by = data_info.search_by
  if (!_.isPlainObject(data)) return
  if (_.isArray(biz_data)) {
    let indexes = tools.findIndexAll(biz_data, search_by)
    _.each(indexes, index => {
      let obj = biz_data[index]
      _.each(data, (v, k) => {
        Vue.set(obj, k, v)
      })
    })
  } else if (_.isPlainObject(biz_data)) {
    _.each(data, (v, k) => {
      Vue.set(biz_data, k, v)
    })
  }
}

// export const get_table_fields = function(
//   vm,
//   code,
//   content_type,
//   setting,
//   include_fields,
//   field_group_num = 0,
//   my_fields_setting = null
// ) {
//   let sortable = false;
//   let filtable = false;
//   let editable = false;

//   if (setting) {
//     sortable = setting.sortable ? setting.sortable : false;
//     filtable = setting.filtable ? setting.filtable : false;
//     editable = setting.editable ? setting.editable : false;
//   }

//   let fields = [];
//   if (my_fields_setting) {
//     _.each(my_fields_setting, function(v, key) {
//       let label = vm.$t(`${content_type}.${key}`);
//       let thClass = ["hb_thead_th", "hb_thead_th_" + key];
//       let tdClass = ["hb_tbody_td", "hb_tbody_td_" + key];
//       fields.push({
//         key,
//         label,
//         sortable,
//         filtable,
//         editable,
//         thClass,
//         tdClass,
//         thStyle: { width: "auto" },
//         type: v.type,
//         primary_key: v.primary_key ? true : false
//       });
//     });
//   } else {
//     let endpoint = get_endpoint(code);

//     if (include_fields) {
//       _.each(include_fields, function(key) {
//         let v = endpoint.response[field_group_num][key];
//         if (v) {
//           let label = vm.$t(`${content_type}.${key}`);
//           let thClass = ["hb_thead_th", "hb_thead_th_" + key];
//           let tdClass = ["hb_tbody_td", "hb_tbody_td_" + key];
//           fields.push({
//             key,
//             label,
//             sortable,
//             filtable,
//             editable,
//             thClass,
//             tdClass,
//             thStyle: { width: "auto" },
//             type: v.type,
//             primary_key: v.primary_key ? true : false
//           });
//         }
//       });
//     } else {
//       _.each(endpoint.response[field_group_num], function(v, key) {
//         let label = vm.$t(`${content_type}.${key}`);
//         let thClass = ["hb_thead_th", "hb_thead_th_" + key];
//         let tdClass = ["hb_tbody_td", "hb_tbody_td_" + key];
//         fields.push({
//           key,
//           label,
//           sortable,
//           filtable,
//           editable,
//           thClass,
//           tdClass,
//           thStyle: { width: "auto" },
//           type: v.type,
//           primary_key: v.primary_key ? true : false
//         });
//       });
//     }
//   }

//   let result = { content_type, fields };
//   result.add_field = function(setting) {
//     let field = setting;
//     field.thClass = ["hb_thead_th", "hb_thead_th_" + field.key];
//     field.tdClass = ["hb_tbody_td", "hb_tbody_td_" + field.key];
//     this.fields.push(field);
//   };
//   result.add_last_blank_field = function() {
//     this.fields.push({
//       key: "_blank",
//       label: "-",
//       type: "string",
//       thStyle: { width: "100%" },
//       thClass: ["hb_thead_th", "hb_thead_th__blank"],
//       tdClass: ["hb_tbody_td", "hb_tbody_td__blank"]
//     });
//   };
//   result.set_field_props = function(key, props) {
//     let field = _.find(this.fields, { key });
//     if (field) {
//       Object.assign(field, props);
//     }
//   };

//   return result;
// };

export const get_entity_fields = function (vm, entity, content_type) {
  let keys = _.keys(entity)
  let fields = _.map(keys, function (k) {
    let v = entity[k]
    let label_text = vm.$t(`${content_type}.${k}`)
    let type = "text"
    if (v !== null) {
      if (_.isNumber(v)) {
        type = _.isInteger(v) ? "integer" : "number"
      } else if (_.isBoolean(v) || v.match(/is_.*/)) {
        type = "boolean"
      } else if (
        parse(v, "yyyy-MM-dd HH:mm:ss", new Date()) ||
        v.match(/^.*_date$/) ||
        v.match(/^.*_date_.*$/)
      ) {
        type = "datetime"
      } else if (
        parse(v, "yyyy-MM-dd", new Date()) ||
        v.match(/^.*_datetime$/) ||
        v.match(/^.*_datetime_.*$/)
      ) {
        type = "date"
      }
    }

    return {
      value_fields: [k],
      type,
      label: { text: label_text, layout: {} },
      editor: { layout: {} }
    }
  })

  let result = { content_type, fields }
  result.get_field = function (key) {
    let field = _.find(this.fields, function (f) {
      return _.indexOf(f.value_fields, key) !== -1
    })
    return field
  }
  result.set_field_props = function (key, props) {
    let field = this.get_field(key)
    if (field) {
      Object.assign(field, props)
    }
  }
  return result
}

export class base_entity_helper {
  constructor(content_type, create, validator) {
    this.content_type = content_type
    this.create = create
    this.validator = validator
    // this.get_table_fields = get_table_fields;
    this.get_entity_fields = get_entity_fields
    this.extract_list = extract_list
    this.extract_oject = extract_oject
  }

  _getAction(code_prefix, parameters) {

    let endpoint_code = code_prefix + "/" + this.content_type
    let _content_type = this.content_type
    return {
      action: function (options) {
        return {
          code: endpoint_code,
          params: parameters.params,
          fields: parameters.fields,
          options: options
        }
      },
      run: function (ref, callback, method = "post") {
        let entryPoint = {}
        entryPoint.url = base_url.base_url + "/" + endpoint_code
        entryPoint.content_type = _content_type
        entryPoint.parameters = parameters
        entryPoint.ref = ref
        entryPoint.method = method
        entryPoint.code = endpoint_code
        return api.query_async(entryPoint, callback)
      }
    }
  }

  execAction(parameters) {
    return this._getAction("data/e", parameters)
  }

  handlerAction(parameters) {
    return this._getAction("data/h", parameters)
  }
  //执行script
  handlerScriptAction(parameters) {
    return this._getAction("data/h/execute_script", parameters)
  }

  checkAction(parameters) {
    return this._getAction("data/x", parameters)
  }

  selectAction(parameters) {
    return this._getAction("data/s", parameters)
  }

  insertAction(parameters) {
    return this._getAction("data/i", parameters)
  }

  updateAction(parameters) {
    return this._getAction("data/u", parameters)
  }

  approveAction(parameters) {
    return this._getAction("data/a", parameters)
  }

  deleteAction(parameters) {
    return this._getAction("data/d", parameters)
  }
  removeAction(parameters) {
    return this._getAction("data/r", parameters)
  }

  validate(item, handlePassed, handleErrors) {
    this.validator.validate(item, (errors, fields) => {
      if (errors) {
        // validation failed, errors is an array of all errors
        // fields is an object keyed by field name with an array of
        // errors per field
        return handleErrors(errors, fields)
      }
      // validation passed
      return handlePassed(item)
    })
  }
}

export const get_endpoint = function (code) {
  // let endpoint = _.find(endpoints_setting.items, { code });
  // if (!endpoint) {
  //   console.log("entry point code not found:" + code);
  //   return {
  //     url: endpoints_setting.base_url + "/" + code,
  //     parameters: null,
  //     response: null,
  //     ref: null
  //   };
  // } else {
  //   let p = _.cloneDeep(endpoint);
  //   p.ref = null;
  //   return p;
  // }
}
